
import {createReducer} from "utils/ReduxUtils";

const initialState = {

}


let EnquiryHandlers = {

} 

export default createReducer(initialState,EnquiryHandlers)


// WEBPACK FOOTER //
// ./src/redux-modules/enquiry/EnquiryReducer.js